// src/scripts/config.js
const CONFIG = {
  BASE_URL: 'https://story-api.dicoding.dev/v1',
  MAPBOX_TOKEN: 'pk.eyJ1Ijoia3NybGNmciIsImEiOiJjbWFvd203MzQwYXRzMmxzM21pMjFzMzV0In0.PWyf3itdGUZGatTpj_qhrQ', // Replace with your token
  DEFAULT_LANGUAGE: 'id-ID',
  CACHE_NAME: 'dicoding-story-v1',
  DATABASE_NAME: 'dicoding-story-database',
  DATABASE_VERSION: 1,
  OBJECT_STORE_NAME: 'stories',
  WEB_SOCKET_SERVER: 'wss://javascript.info/article/websocket/chat/ws',
  PUSH_MSG_VAPID_PUBLIC_KEY: 'BCCs2eonMI-6H2ctvFaWg-UYdDv387Vno_bzUzALpB442r2lCnsHmtrx8biyPi_E-1fSGABK_Qs_GlvPoJJqxbk',
};

export default CONFIG;